import { Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from '../app/page'
import CoursesCatalogPage from '../app/courses/page'
import CourseDetailPage from '../app/courses/[id]/page'
import FreeTrialPage from '../pages/free-trial/page'
import TeachersPage from '../pages/teachers/page'
import AboutPage from '../pages/about/page'
import ReviewsPage from '../pages/reviews/page'
import ContactPage from '../pages/contact/page'
import { Analytics } from '@vercel/analytics/react'
import BlogPage from '../pages/blog/page'
import BlogDetailPage from '../pages/blog/[slug]/page'
import PricingPage from '../pages/pricing/page'
import { FloatingWhatsApp } from '../components/floating-whatsapp'

function App() {
  return (
    <BrowserRouter>
      <div className="font-sans">
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/courses" element={<CoursesCatalogPage />} />
            <Route path="/courses/:id" element={<CourseDetailPage />} />
            <Route path="/free-trial" element={<FreeTrialPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/teachers" element={<TeachersPage />} />
            <Route path="/about" element={<AboutPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Suspense>
        <FloatingWhatsApp />
        <Analytics />
      </div>
    </BrowserRouter>
  )
}

export default App